'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';

export default function Home() {
  const router = useRouter();
  const [message, setMessage] = useState('Loading...');

  useEffect(() => {
    // Check for location in localStorage or cookies
    if (typeof window !== 'undefined') {
      console.log('[Home] Checking for stored location');
      
      // Try to get location from localStorage first
      const storedLocation = localStorage.getItem('restaurantLocation');
      console.log(`[Home] Location from localStorage: ${storedLocation || 'not found'}`);
      
      // Handle redirection based on stored location (check for full names)
      if (storedLocation === 'Mimosa Brookfield') {
        console.log('[Home] Redirecting to Brookfield');
        setMessage('Redirecting to Brookfield...');
        router.push('/mimosa-brookfield');
      } else if (storedLocation === 'Mimosa Franklin') {
        console.log('[Home] Redirecting to Franklin');
        setMessage('Redirecting to Franklin...');
        router.push('/mimosa-franklin');
      } else {
        // If no location is stored, show location selection
        console.log('[Home] No location found, showing selection');
        setMessage('Please select a location');
      }
    }
  }, [router]);

  // Handle location selection
  const selectLocation = (location: 'brookfield' | 'franklin') => {
    console.log(`[Home] Selected location: ${location}`);
    
    // Store the selection with full location name to match what location pages expect
    const fullLocationName = location === 'brookfield' ? 'Mimosa Brookfield' : 'Mimosa Franklin';
    localStorage.setItem('restaurantLocation', fullLocationName);
    document.cookie = `restaurantLocation=${fullLocationName}; path=/; max-age=31536000`; // 1 year
    
    // Redirect to the location-specific page
    router.push(`/mimosa-${location}`);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white">
      <h1 className="text-3xl font-bold text-brand mb-8">Mimosa Restaurant</h1>
      
      {message === 'Please select a location' ? (
        <div className="space-y-4">
          <p className="text-xl text-gray-700 mb-4">Please select a location:</p>
          <div className="flex space-x-4">
            <button
              onClick={() => selectLocation('brookfield')}
              className="px-6 py-3 bg-brand text-white rounded-md shadow hover:bg-brand-dark transition-colors"
            >
              Brookfield
            </button>
            <button
              onClick={() => selectLocation('franklin')}
              className="px-6 py-3 bg-brand text-white rounded-md shadow hover:bg-brand-dark transition-colors"
            >
              Franklin
            </button>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center">
          <p className="text-xl text-gray-700">{message}</p>
          <div className="mt-4 animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-brand"></div>
        </div>
      )}
    </div>
  );
}
